import { takeLatest } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getAllList } from '../api';

export default function* saga() {
  yield takeLatest(types.GET_ALL_LIST, getPaginatedListSaga(actions, getAllList));
}
